/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Promo_Gallery_Empty_HintInputs */



/**
* | output |
* | --- |
* | "Promotional cards and packs will appear here." |
*
* @param {Promo_Gallery_Empty_HintInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const promo_gallery_empty_hint = /** @type {((inputs?: Promo_Gallery_Empty_HintInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Promo_Gallery_Empty_HintInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Les cartes et lots promotionnels apparaîtront ici.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Las cartas y lotes promocionales aparecerán aquí.")
	if (locale === "pt") return /** @type {LocalizedString} */ ("As cartas e pacotes promocionais aparecerão aqui.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Le carte e i pacchetti promozionali appariranno qui.")
	return /** @type {LocalizedString} */ ("Promotional cards and packs will appear here.")
});